import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => setUser(false));
  }, []);

  const logout = async () => {
    await api.post("/auth/logout");
    localStorage.removeItem("ukj_token");
    setUser(false);
  };

  const applyAuth = (data) => {
    if (data.access_token) localStorage.setItem("ukj_token", data.access_token);
    setUser(data);
  };

  return (
    <AuthContext.Provider value={{ user, setUser: applyAuth, logout, isMember: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
